import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, ReactNode } from 'react';

const alert = cva(['alert', 'alert-dismissible'], {
    variants: {
        intent: {
            primary: ['alert-primary'],
            secondary: ['alert-secondary'],
            info: ['alert-info'],
            success: ['alert-success'],
            warning: ['alert-warning'],
            danger: ['alert-danger'],
        },
    },
    defaultVariants: {
        intent: 'info',
    },
});

const icon = cva(['text-color-info', 'text-size-h4', 'margin-right-10', 'rioglyph'], {
    variants: {
        intent: {
            primary: ['rioglyph-info-sign'],
            secondary: ['rioglyph-info-sign'],
            info: ['rioglyph-info-sign'],
            success: ['rioglyph-ok-sign'],
            warning: ['rioglyph-exclamation-sign'],
            danger: ['rioglyph-error-sign'],
        },
    },
    defaultVariants: {
        intent: 'primary',
    },
});

export type AlertProps = VariantProps<typeof alert> &
    Omit<HTMLAttributes<HTMLDivElement>, 'content'> & {
        open?: boolean;
        onOpenChange?: ((open: boolean) => void) | undefined;
        title?: string;
        content: ReactNode;
    };

const Alert = ({ title, content, intent, className, children, onOpenChange, open = true, ...props }: AlertProps) =>
    open ? (
        <div className={alert({ intent, className })} {...props}>
            {onOpenChange ? (
                <button
                    type='button'
                    className='btn btn-icon-only close'
                    data-dismiss='alert'
                    onClick={() => onOpenChange(false)}
                >
                    <span className='rioglyph rioglyph-remove' />
                </button>
            ) : null}
            <div className='display-flex'>
                <span className={icon({ intent })} />
                <div>
                    {title ? <strong className='text-size-16'>{title}</strong> : null}
                    <div className={title ? 'margin-y-5' : ''}>{content}</div>
                    {children}
                </div>
            </div>
        </div>
    ) : null;

export default Alert;
